<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.97925 3.75C6.63204 3.75 4.72925 5.65279 4.72925 8V16C4.72925 18.3472 6.63204 20.25 8.97925 20.25H16.9792C19.3264 20.25 21.2292 18.3472 21.2292 16V8C21.2292 5.6528 19.3264 3.75 16.9792 3.75H8.97925ZM3.22925 8C3.22925 4.82437 5.80361 2.25 8.97925 2.25H16.9792C20.1549 2.25 22.7292 4.82436 22.7292 8V16C22.7292 19.1756 20.1549 21.75 16.9792 21.75H8.97925C5.80361 21.75 3.22925 19.1756 3.22925 16V8ZM18.991 5.94144C19.2989 6.21854 19.3238 6.69276 19.0467 7.00063L19.0367 7.01174C18.7596 7.31962 18.2854 7.34456 17.9775 7.06745C17.6696 6.79035 17.6447 6.31613 17.9218 6.00826L17.9318 5.99715C18.2089 5.68928 18.6831 5.66433 18.991 5.94144ZM8.22925 12C8.22925 9.37665 10.3559 7.25 12.9792 7.25C15.6026 7.25 17.7292 9.37664 17.7292 12C17.7292 14.6233 15.6026 16.75 12.9792 16.75C10.3559 16.75 8.22925 14.6233 8.22925 12ZM12.9792 8.75C11.1843 8.75 9.72925 10.2051 9.72925 12C9.72925 13.7949 11.1843 15.25 12.9792 15.25C14.7741 15.25 16.2292 13.7949 16.2292 12C16.2292 10.2051 14.7741 8.75 12.9792 8.75Z"
			fill="black"
		/>
	</svg>
</template>
